import { Translator } from 'Translator';
import { Observable } from 'rxjs';

import availableLanguages from '../../resources/languages.json';
import { history } from '../wlHistory';
import { isWeb } from './platform';

export const urls$ = Observable.create((observer) =>
  history.listen(() => observer.next()),
)
  .startWith(1)
  .map(() => window.location.pathname)
  .filter((x) => !!x && x !== 'undefined' && x !== 'null')
  .debounceTime(50) // @see {@link https://bitbucket.org/withlocals/withlocals-user-environment/pull-requests/1510/fix-multiple-analytics-page-events/diff}
  .distinctUntilChanged()
  .do((path) => {
    console.log(`url$ ${path}`);
  });

function capitalizeFirstLetter(val: string): string {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

const screenTitleInternal = (fullPathname) => {
  let pathname = fullPathname;
  const parts = fullPathname.split('/').filter((x) => !!x);
  if (availableLanguages.includes(parts[0])) {
    parts.splice(0, 1);
    pathname = '/' + parts.join('/');
  }

  if (pathname === '/') {
    return Translator.translate(
      'Homepage.Meta.title',
      {},
      true,
      'Enjoy a city like a local - unique things to do, private tours & home dinners',
    );
  }

  if (pathname.startsWith('/messages')) {
    return Translator.translate(
      'UserEnvironment.Navigation.messages',
      {},
      true,
      'Messages',
    );
  }

  if (pathname.startsWith('/schedule')) {
    return 'Agenda';
  }

  if (pathname.startsWith('/action')) {
    return 'Actions';
  }

  if (pathname.startsWith('/login')) {
    return 'Log in';
  }

  if (pathname.startsWith('/signup')) {
    return Translator.translate('Forms.Buttons.signUp', {}, true, 'Sign up');
  }

  if (
    pathname.startsWith('/host/home') ||
    pathname.startsWith('/host/dashboard')
  ) {
    return 'Homepage';
  }

  if (pathname.startsWith('/host-agenda')) {
    return 'Agenda';
  }

  if (pathname.startsWith('/more')) {
    return 'Settings';
  }

  if (pathname.includes('newoffer')) {
    return 'Create new offer';
  }

  if (pathname.includes('offer')) {
    return 'Create offer';
  }

  if (parts[0] === 'booking') {
    if (parts[2] === 'bookingdetails') {
      return 'Checkout Details';
    }
    if (parts[2] === 'payment') {
      return 'Checkout Payment';
    }
    return 'Checkout';
  }

  if (parts[0] === 'confirmation') {
    return 'Confirmation';
  }

  if (parts[0] === 'experiences' && parts.length > 1) {
    const locationTitlePart = parts
      .slice(1)
      .reverse()
      .map(capitalizeFirstLetter)
      .join(', ');
    return `Search ${locationTitlePart}`;
  }

  return '';
};

export const screenTitle = (fullPathname = window.location.pathname) => {
  const base = screenTitleInternal(fullPathname);
  const postfix = base === '' ? 'Withlocals' : ' - Withlocals';
  if (isWeb() && !base.endsWith(postfix)) {
    return `${base}${postfix}`;
  }
  return base;
};
